// extracted by mini-css-extract-plugin
export default {"form":"FormContact_form__9bh37","formBody":"FormContact_formBody__uAmCT"};